import debounce from '../utilities/debouncer';

export default class {
    constructor({
        id,
        activeClass = 'is-active',
    }) {
        const el = document.getElementById(id);

        let { innerHeight: height } = window;

        window.addEventListener('resize', debounce(() => {
            height = window.innerHeight;
        }, 300));
        window.addEventListener('scroll', () => {
            const { scrollY: y } = window;
            const belowHeader = y > (height * 0.5);
            const aboveFooter = y < (document.body.scrollHeight - (height * 1.5));

            el.classList.toggle(activeClass, belowHeader && aboveFooter);
        });
    }
}
